import Moment from 'moment';
import * as Formatting from 'fw/misc/Formatting'

class DateRangeHelper {
    // custom -> force empty dates
    custom = () => {
        return { option: "custom", start: "", end: "" }
    }

    // today
    today = () => {
        return { option: "today", start: Formatting.formatDate(Moment()), end: Formatting.formatDate(Moment()) }
    }

    // yesterday
    yesterday = () => {
        return { option: "yesterday", start: Formatting.formatDate(Moment().add(-1, 'day')), end: Formatting.formatDate(Moment().add(-1, 'day')) }
    }

    // this week
    thisWeek = () => {
        const start = Moment().add(- (Moment().day() - 1), 'day');
        const end = start.clone().add(6, 'day');
        return { option: "thisWeek", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // this month
    thisMonth = () => {
        const start = Moment().date(1);
        const end = start.clone().add(1, 'months').add(-1, 'day');
        return { option: "thisMonth", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // this year
    thisYear = () => {
        const start = Moment().month(0).date(1);
        const end = Moment().month(11).date(31);
        return { option: "thisYear", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // month to date
    MTD = () => {
        const start = Moment().date(1);
        const end = Moment();
        return { option: "MTD", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // year to date
    YTD = () => {
        const start = Moment().month(0).date(1);
        const end = Moment();
        return { option: "YTD", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // last week
    lastWeek = () => {
        const start = Moment().add(-(Moment().weekday() - 0), 'day').add(-7, 'day');
        const end = start.clone().add(6, 'day');
        return { option: "lastWeek", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // last 2 weeks
    last2Weeks = () => {
        const start = Moment().add(-14, 'day');
        const end = Moment();
        return { option: "last2Weeks", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // last 30 days
    last30Days = () => {
        const start = Moment().add(-30, 'day');
        const end = Moment();
        return { option: "last30Days", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // last month
    lastMonth = () => {
        const start = Moment().date(1).add(-1, 'months');
        const end = start.clone().add(1, 'months').add(-1, 'day');
        return { option: "lastMonth", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // last Q
    lastQuarter = () => {
        const start = Moment().add(-1,'quarter').startOf('quarter');
        const end = start.clone().endOf('quarter');
        return { option: "lastQuarter", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // last 3 months
    last3Months = () => {
        const start = Moment().add(-3, 'months');
        const end = Moment();
        return { option: "last3Months", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // last 6 months
    last6Months = () => {
        const start = Moment().add(-6, 'months');
        const end = Moment();
        return { option: "last6Months", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // last year
    lastYear = () => {
        const start = Moment().add(-1, 'year').month(0).date(1);
        const end = start.clone().add(1, 'years').add(-1, 'day');
        return { option: "lastYear", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // last 2 years
    last2Years = () => {
        const start = Moment().add(-2, 'year').month(0).date(1);
        const end = start.clone().add(1, 'years').add(-1, 'day');
        return { option: "last2Years", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // next week
    nextWeek = () => {
        const start = Moment().add(-(Moment().weekday() - 0), 'day').add(7, 'day');
        const end = start.clone().add(6, 'day');
        return { option: "nextWeek", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // next month
    nextMonth = () => {
        const start = Moment().date(1).add(1, 'months');
        const end = start.clone().add(1, 'months').add(-1, 'day');
        return { option: "nextMonth", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // next year
    nextYear = () => {
        const start = Moment().add(1, 'year').month(0).date(1);
        const end = start.clone().add(1, 'years').add(-1, 'day');
        return { option: "nextYear", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // this Q
    thisQuarter = () => {
        const start = Moment().startOf('quarter');
        const end = Moment().endOf('quarter');
        return { option: "currentQuarter", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // next Q
    nextQuarter = () => {
        const start = Moment().add(1, 'quarter').startOf('quarter');
        const end = start.clone().endOf('quarter');
        return { option: "currentQuarter", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // year ending
    yearEnding = () => {
        const start = Moment().add(-1, 'year');
        const end = Moment();
        return { option: "yearEnding", start: Formatting.formatDate(start), end: Formatting.formatDate(end) }
    }

    // all dates (??)
    allDates = () => {
        return { option: "allDates", start: "", end: "" }
    }

    // Filters
    futureOnly = (current) => {
        return current.isAfter(Moment().subtract(1, 'day'));
    }

    pastOnly = (current) => {
        return current.isBefore(Moment());
    }

    workDays = (current) => {
        return ([1, 2, 3, 4, 5].indexOf(current.day()) !== -1);
    }
}

export default DateRangeHelper;


// WEBPACK FOOTER //
// ./src/fw/forms/helpers/DateRangeHelper.js